(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-party-rentals"] && !Shopify.designMode) return;
  try {
    

function initRentals(scope=document){scope.querySelectorAll('[data-rentals]').forEach(root=>{const form=root.querySelector('form');if(!form||form.dataset.rentalsReady)return;form.dataset.rentalsReady='true';const pickup=form.querySelector('[data-field="pickup"]'),ret=form.querySelector('[data-field="return"]');if(!pickup)return;const quantities=[...form.querySelectorAll('[data-qty]')],error=form.querySelector('[data-error]');const buttons=[...root.querySelectorAll('[data-add-item]')];const syncButtons=()=>buttons.forEach(btn=>{const input=form.querySelector('[name="contact['+btn.dataset.addItem+' quantity]"]');const selected=Number(input?.value)>0;btn.setAttribute('aria-pressed',String(selected));btn.setAttribute('aria-label',selected?btn.dataset.labelRemove:btn.dataset.labelAdd);btn.textContent=root.querySelector(selected?'[data-remove-text]':'[data-add-text]').textContent;});buttons.forEach(btn=>btn.addEventListener('click',()=>{const input=form.querySelector('[name="contact['+btn.dataset.addItem+' quantity]"]');if(!input)return;const adding=Number(input.value)===0;input.value=adding?'1':'0';input.dispatchEvent(new Event('input',{bubbles:true}));root.querySelector('[data-selection-status]').textContent=root.querySelector(adding?'[data-added-notice]':'[data-removed-notice]').textContent;syncButtons();}));const syncDeposit=()=>{const rates={castle:100,jbl320:100,jbl520:200,microphones:50,light:50,arch:25};let total=0;for(const [item,rate] of Object.entries(rates)){const input=form.querySelector('[name="contact['+item+' quantity]"]');total+=Math.max(0,Number(input?.value)||0)*rate;}total=Math.min(500,total);form.querySelector('[data-deposit-total]').textContent='$'+total+' CAD';form.querySelector('[data-deposit-value]').value=String(total);form.querySelector('[data-sign-deposit]').hidden=!(Number(form.querySelector('[name="contact[sign quantity]"]').value)>0);};form.addEventListener('input',syncDeposit);syncDeposit();form.addEventListener('input',syncButtons);syncButtons();const validate=()=>{quantities[0].setCustomValidity(quantities.some(i=>Number(i.value)>0)?'':form.querySelector('[data-select-error]').textContent);pickup.setCustomValidity(pickup.value&&new Date(pickup.value)<=new Date()?form.querySelector('[data-past-error]').textContent:'');ret.min=pickup.value;ret.setCustomValidity(pickup.value&&ret.value&&ret.value<=pickup.value?form.querySelector('[data-date-error]').textContent:'');};const defaultReturn=()=>{if(!pickup.value)return;const [day,time]=pickup.value.split('T');const date=new Date(day+'T12:00:00Z');if(Number.isNaN(date.getTime())||!time)return;date.setUTCDate(date.getUTCDate()+2);ret.value=date.toISOString().slice(0,10)+'T10:00';};if(pickup.value&&!ret.value)defaultReturn();form.addEventListener('input',e=>{if(e.target===pickup)defaultReturn();validate();if(e.target.matches('[data-qty],[data-field]'))form.querySelector('[data-agree]').checked=false;error.textContent='';});form.addEventListener('submit',e=>{validate();if(!form.checkValidity()){e.preventDefault();form.reportValidity();}});validate();});}initRentals();document.addEventListener('shopify:section:load',e=>initRentals(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
